import "./CostTab.css";

import RoundedBox from "../../../Components/RoundedBox/RoundedBox";
import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";


function CostTab({ }) {
    const CustomRoundBoxStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '300px',
        padding: '30px'
    };


    return (
        <div className="cost-tab">
            <div className="cost-tab-title">
                기획 출판, 비용은 어떻게 책정될까요?
            </div>

            <div className="cost-tab-box-row">
                <div className="cost-tab-labelled-box">
                    <div className="cost-tab-box-label">
                        기획 출판 저작자 부담분 기준
                    </div>
                    <div className="cost-tab-box-contents">
                        기본적으로 저작자 비용 부담이 없습니다
                    </div>
                </div>
                <div className="cost-tab-row-plus">+</div>
                <div className="cost-tab-labelled-box">
                    <div className="cost-tab-box-contents">
                        <div className="cost-tab-box-text-bold">
                            <strong>저자 스튜디오</strong>
                        </div>
                        <div className="cost-tab-box-text">
                            저자 스튜디오를 통해 아래 서비스를 지원 받을 수 있습니다.
                        </div>

                        <div className="cost-tab-box-text">
                            <TextWithLineBreaks text={"\n- 진행사항 관리 : 출판 과정 실시간 모니터링 \n- 판매 현황 확인 : 실시간 판매 데이터 조회 \n- 인세 정산 : 자동 정산 및 세무 서류 제공 \n- 커뮤니티 지원 : 저자 간 정보 교류 및 네트워킹 \n- 저술 업무 지원 : 저술 참조 자료 , 독자 소통 기능 등"} />
                        </div>
                    </div>
                </div>
                <div className="cost-tab-row-plus">+</div>
                <div className="cost-tab-labelled-box">
                    <div className="cost-tab-box-contents">
                        <div className="cost-tab-box-text-bold">
                            <strong>특별요청</strong>
                        </div>
                        <div className="cost-tab-box-text">                            
                            <TextWithLineBreaks text={"저작자가 별도 요청한 \n추가 서비스가 있을 경우"} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="cost-tab-spacer" />

            <div className="cost-tab-title">
                선급금(계약금)
            </div>

            <div className="cost-tab-box-row">
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        신인 작가
                    </div>
                    <div className="cost-tab-box-desc">
                        100 ~ 300만 원
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        경력 작가
                    </div>
                    <div className="cost-tab-box-desc">
                        300 ~ 700만 원
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        유명 작가
                    </div>
                    <div className="cost-tab-box-desc">
                        1,000만 원 ~
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        전문서적
                    </div>
                    <div className="cost-tab-box-desc">
                        시장성에 따라 차등 지급
                    </div>
                </RoundedBox>
            </div>

            <div className="cost-tab-spacer" />

            <div className="cost-tab-title">
                인세율
            </div>

            <div className="cost-tab-box-row">
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        종이책
                    </div>
                    <div className="cost-tab-box-desc">
                        정가의 10~12%
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        전자책
                    </div>
                    <div className="cost-tab-box-desc">
                        순수입의 20%
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        해외 출판
                    </div>
                    <div className="cost-tab-box-desc">
                        별도 협의
                    </div>
                </RoundedBox>
                <RoundedBox style={CustomRoundBoxStyle}>
                    <div className="cost-tab-box-title">
                        2차 저작물(영화화, 드라마화 등)
                    </div>
                    <div className="cost-tab-box-desc">
                        수익의 50%
                    </div>
                </RoundedBox>
            </div>

            <div className="cost-tab-spacer" />
        </div>
    );
}

export default CostTab;